var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.promotion)?_c('b-row',[_c('b-col',[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.promotion.imageSourceUrl,"alt":_vm.imgAltText}})])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }